<template>
  <button
    type="button"
    class="flex items-center justify-between rounded-full bg-background p-1"
    @click="showDrawer"
  >
    <span class="mx-2 line-clamp-1 text-xs font-medium">
      {{ label }}
    </span>
    <IconChevronDown
      class="rounded-full bg-background-fg/10"
    />
  </button>

  <BaseDrawer
    :is-open="isVisible"
    shrink
    @close="hideDrawer"
  >
    <div class="p-4">
      <BaseDatePicker
        :model-value="modelValue"
        disable-future
        allow-all-time
        @update:model-value="handleUpdateDate"
      />
    </div>
  </BaseDrawer>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string | null
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: string | null): void
}>()

const handleUpdateDate = (date: string | null) => {
  emit("update:modelValue", date)
  hideDrawer()
}

const { isVisible, showDrawer, hideDrawer } =
  useDrawerState()

const label = computed(() =>
  props.modelValue
    ? formatToDate(props.modelValue)
    : "All Time"
)
</script>

<style lang="scss" module>
.squareHack {
  position: relative;
  padding-top: 100%;
}
</style>
